export type ConsentTier = "open" | "strict" | "superstrict";

/**
 * Countries where no analytics scripts may run until the user provides
 * explicit consent (CNIL hardline — no pre-consent script loading).
 */
const SUPERSTRICT_COUNTRIES = new Set(["FR"]);

/**
 * Countries where Consent Mode v2 cookieless pings are acceptable before
 * consent is given, but a banner must be shown (GDPR / ePrivacy jurisdictions).
 * France is excluded — it belongs to SUPERSTRICT_COUNTRIES.
 */
const STRICT_COUNTRIES = new Set([
    // EU/EEA minus France
    "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "DE",
    "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL",
    "PT", "RO", "SK", "SI", "ES", "SE", "IS", "LI", "NO",
    // Other strict jurisdictions
    "GB", "CH", "BR",
]);

/**
 * Returns the consent tier for a given ISO 3166-1 alpha-2 country code.
 * Null / unknown country → strict (banner + Consent Mode cookieless pings).
 */
export function getConsentTier(country: string | null | undefined): ConsentTier {
    if (!country) return "strict";
    const c = country.toUpperCase();
    if (SUPERSTRICT_COUNTRIES.has(c)) return "superstrict";
    if (STRICT_COUNTRIES.has(c)) return "strict";
    return "open";
}
